// @ts-nocheck
class FabricSamples extends HTMLElement {
  constructor() {
    super();

    this.MAX_SAMPLES = 5;
    this.selectedItems = new Map(); // variantId -> { name, image, hexcode }
    this.button = this.querySelector('.order-fabric-sample-button');
    this.placeholders = Array.from(this.querySelectorAll('.fabric-placeholder'));

    this.querySelectorAll('input[name="product-item"]').forEach(input => {
      input.addEventListener('change', () => this.#onInputChange(input));
    });

    this.placeholders.forEach(placeholder => {
    placeholder.querySelector('.remove-fabric-button')?.addEventListener('click', () => {
      this.#onRemove(placeholder);
    });
  });

    this.#updateUI();
  }

  #onInputChange(input) {
    const variantId = input.value;
    const item = input.closest('.fabric-sample-item');
    const name = item?.dataset.colorName || '';
    const img = item?.querySelector('img');
    const swatch = item?.querySelector('.item-swatch-inner');
    const hexcode = swatch?.style.backgroundColor || '';
    const imageSrc = img?.src || '';

    if (input.checked) {
      if (this.selectedItems.size >= this.MAX_SAMPLES) {
        input.checked = false;
        return;
      }
      this.selectedItems.set(variantId, { name, imageSrc, hexcode });
    } else {
      this.selectedItems.delete(variantId);
    }

    this.#updateUI();
  }

  #onRemove(placeholder) {
    const variantId = placeholder.dataset.variantId;
    if (!variantId) return;

    // Uncheck the input
    const input = this.querySelector(`input[value="${variantId}"]`);
    if (input) input.checked = false;

    this.selectedItems.delete(variantId);
    this.#updateUI();
  }

  #updateUI() {
    const selected = Array.from(this.selectedItems.entries());

    // Update placeholders
    this.placeholders.forEach((placeholder, index) => {
      const inner = placeholder.querySelector('.fabric-placeholder-inner');
      const removeBtn = placeholder.querySelector('.remove-fabric-button');
      inner.innerHTML = '';
      inner.style.backgroundColor = '';
      placeholder.classList.remove('filled');
      placeholder.dataset.variantId = '';

      const item = selected[index];

      if (item) {
        const [variantId, data] = item;
        placeholder.classList.add('filled');
        placeholder.dataset.variantId = variantId;

        if (data.imageSrc) {
          const img = document.createElement('img');
          img.src = data.imageSrc;
          img.alt = data.name;
          inner.appendChild(img);
        } else if (data.hexcode) {
          inner.style.backgroundColor = data.hexcode;
        }
      }
    });

    // Disable all unchecked inputs if max reached
    const maxReached = this.selectedItems.size >= this.MAX_SAMPLES;
    this.querySelectorAll('input[name="product-item"]').forEach(input => {
      if (!input.checked) {
        input.disabled = maxReached;
        input.closest('.fabric-sample-item')?.classList.toggle('disabled', maxReached);
      }
    });

    // Update button state
    if (this.button) {
      this.button.disabled = this.selectedItems.size === 0;
    }
  }

  clearSelectedItems() {
     this.selectedItems.clear();
  
    // Uncheck all inputs
    this.querySelectorAll('input[name="product-item"]:checked').forEach(input => {
      input.checked = false;
    });

    this.#updateUI();
  }

  getSelectedItems() {
    return Array.from(this.selectedItems.keys());
  }
}

if (!customElements.get('fabric-samples')) {
  customElements.define('fabric-samples', FabricSamples);
}